import intradaysEntriesTableTemplate from './reactIntradayEntriesTable.html';
import { AccountService } from '../../../services/AccountService';
import { accounts, intradays, transactions, USER_ACC_REACT, TRANSACTION_TYPES } from '../../../services/arsweb/RoutingPaths';
import { reactTransactionCols } from '../transactions/transactionsDetailColDefs';
import { defaultSortModel } from '../statementTransactions/reactStatementTransactionsTable.directive';
import { INTRADAY_ENTRIES_TITLE } from '../../../services/arsweb/TableTitles';
import {ReactTableController} from "../reactTableController";
import { REPORT_TYPE } from '../../report/ReportModalController';
import {SearchableItemService} from "../../../services/SearchableItemService";

export const TABLEPARAMS = 'intradayEntriesTableParams';

/** @ngInject */
export function reactIntradayEntriesTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            fractionDigits: '=',
            hideColumns: '=',
            noInitTotal: '=',
            height: '@'
        },
        templateUrl: intradaysEntriesTableTemplate,
        controller: ReactIntradayEntriesTableController,
        controllerAs: 'intradayEntriesTableController'
    };
}

/** @ngInject */
export class ReactIntradayEntriesTableController extends ReactTableController {
    constructor($scope, userService, arsMainDependencies) {

        const intradayID = arsMainDependencies.$state.params.id;

        const reportOptions = {options: [ REPORT_TYPE.PDF_TRANSACTION_INTRADAY, REPORT_TYPE.XLS_TRANSACTION_INTRADAY_REPORT,
                                            REPORT_TYPE.CSV_TRANSACTION_INTRADAY_REPORT, REPORT_TYPE.MT942_ACTUAL_INTRADAY,
                                            REPORT_TYPE.PDF_ACTUAL_INTRADAY ]};

        super($scope, userService, arsMainDependencies, null, new AccountService(userService),
            `${accounts}${intradays}/${intradayID}${transactions}`, INTRADAY_ENTRIES_TITLE, TABLEPARAMS, "transactionID",
            true, reportOptions, defaultSortModel);

        this.isUserReport = false;
        const searchService = new SearchableItemService(userService);
        const transactionTypesPromise = searchService.backendService.getUserData(`${TRANSACTION_TYPES}${intradays}/${intradayID}`);

        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService, intradayID, transactionTypesPromise));
        
        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService, intradayId, transactionTypesPromise) {
        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactTransactionCols(this.translate, userService.filterFormatter, transactionTypesPromise,
                this.fractionDigits, { showCamt052: true });
            this.initCols();
            // react gridParameters for account table
            const intradayEntriesGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(`${USER_ACC_REACT}${intradays}/${intradayId}${transactions}`),
                requestParams: this.backendService.service.config.params};
            this.reactGridParams = {...this.defaultReactGridParams, ...intradayEntriesGridParams};
        });
    }

    updateReportTypesForSelection() {
        const options = this.exportController.reportOptions.options;
        // Remove previous CAMT052 if present
        this.exportController.reportOptions.options = options.filter(opt =>
            opt !== REPORT_TYPE.CAMT052_ACTUAL_INTRADAY
        );

        // Add CAMT052 if flag is true for this grid
        if (this.getCamt05xFlag()) {
            this.exportController.reportOptions.options.push(REPORT_TYPE.CAMT052_ACTUAL_INTRADAY);
        }
    }
}
